"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTypeMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const icons_1 = require("./common/icons");
const react_dnd_1 = require("react-dnd");
const Mapper_1 = require("../utils/Mapper");
exports.IconTypeMap = {
    textarea: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.TextAreaIcon, {}), label: "Textarea" },
    text: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.TextFieldIcon, {}), label: "Text Field" },
    radio: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.MultipleChoiceIcon, {}), label: "Multiple choice" },
    checkbox: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.CheckboxIcon, {}), label: "Check-boxes" },
    select: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.DropdownIcon, {}), label: "Drop-down" },
    file: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.FileUploadIcon, {}), label: "File Upload" },
    'datetime-local': { icon: () => (0, jsx_runtime_1.jsx)(icons_1.DateIcon, {}), label: "Date" },
    time: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.TimeIcon, {}), label: "Time" },
    number: { icon: () => (0, jsx_runtime_1.jsx)(icons_1.PhoneIcon, {}), label: "Phone Number" },
};
const QuestionCard = ({ type, question, questionObj, disabled = false }) => {
    const mappedType = Mapper_1.TypeDropFormMapper[type];
    const { icon: Icon, label } = exports.IconTypeMap[mappedType] || {
        icon: () => null,
        label: "Unknown",
    };
    const paperRef = (0, react_1.useRef)(null);
    const [{ isDragging }, dragRef] = (0, react_dnd_1.useDrag)(() => ({
        type: "form-element",
        item: questionObj ? Object.assign({}, questionObj) : {
            type,
            label,
            question,
            config: {
                label: question,
                required: false,
            },
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        canDrag: !disabled, // Disable dragging if the card is disabled
    }));
    // Apply drag ref manually
    (0, react_1.useEffect)(() => {
        if (paperRef.current) {
            dragRef(paperRef.current);
        }
    }, [dragRef]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { ref: paperRef, variant: "outlined", sx: {
            p: 1.5,
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
            borderRadius: 2,
            borderColor: disabled ? "#ccc" : "#d0bfff",
            boxShadow: "none",
            opacity: disabled ? 0.5 : (isDragging ? 0.5 : 1),
            cursor: disabled ? "not-allowed" : "grab",
            backgroundColor: disabled ? "#f5f5f5" : "white",
            "&:hover": {
                backgroundColor: disabled ? "#f5f5f5" : "#f8f8f8",
            },
        }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { color: disabled ? "#999" : "#7356fa", children: Icon && (0, jsx_runtime_1.jsx)(Icon, {}) }), (0, jsx_runtime_1.jsxs)(material_1.Box, { flex: 1, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { fontSize: "0.85rem", fontWeight: 600, color: disabled ? "text.disabled" : "text.primary", children: label }), (0, jsx_runtime_1.jsx)(material_1.Typography, { fontSize: "0.75rem", color: disabled ? "text.disabled" : "text.secondary", children: question }), disabled && ((0, jsx_runtime_1.jsx)(material_1.Typography, { fontSize: "0.7rem", color: "text.disabled", sx: { mt: 0.5, fontStyle: "italic" }, children: "Already added to form" }))] })] }));
};
exports.default = QuestionCard;
